import React, { useEffect } from 'react';

import { getRecordTimeLineItems } from './utils/getTimelineItems';

export function RecordsTimelineRides({ currentDate, rideRecords }) {
  useEffect(() => {
    const intervalId = setInterval(() => {}, 1000);

    return () => clearInterval(intervalId);
  }, []);

  console.log('RENDERED RIDE RECORDS', rideRecords);

  return getRecordTimeLineItems(rideRecords, currentDate).map((item, index) => (
    <React.Fragment key={index}>
      <line
        x1={`${item.start}%`}
        y1="55%"
        x2={`${item.end}%`}
        y2="55%"
        stroke={'hsla(180, 50%, 70%)'}
        strokeWidth={15}
        id={`break-${index}`}
      />
    </React.Fragment>
  ));
}
